import React, { useState } from "react";
import { Navbar, Input, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Button, Row, Col, Modal, ModalBody, ModalHeader, Label, FormGroup, Alert } from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import { logout, getUserInfo } from "../Utilities/Auth";
import Navigation from "./Navigation";
import logo from "../Assets/images/logo.png"
import "../Assets/css/--layout.css";
import { updatePassword, addCompany } from "../API/Backend";
import { showToast } from "../Components/Toast"
import { ToastContainer } from "react-toastify";
import { getToken } from "../Utilities/Auth"; // make sure this is imported at the top
import { useClient } from "../Utilities/ClientContext";

export default function AdminLayout(props) {
  const { clients, activeClient, setActiveClient, refreshClients } = useClient();
  // Client admins are limited to one client by the backend; hide all-client actions
  const isClientAdmin = Boolean(getUserInfo()?.user?.clientName);
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [clientDropdownOpen, setClientDropdownOpen] = useState(false);
  const [addClientModal, setAddClientModal] = useState(false);
  const [newClient, setNewClient] = useState({ clientName: "", companyName: "" });
  const [addClientLoading, setAddClientLoading] = useState(false);
  const [viewModal, setViewModal] = useState(false);
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [repeatPassword, setRepeatPassword] = useState("");
  const [showPassword, setShowPassword] = useState({ oldPassword: false, newPassword: false, repeatPassword: false });
  const [errors, setErrors] = useState({ oldPassword: "", newPassword: "", repeatPassword: "", apiError: "" });
  const [loading, setLoading] = useState(false);

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);
  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);
  const toggleClientDropdown = () => setClientDropdownOpen(!clientDropdownOpen);

  const handleAddClient = (e) => {
    e.preventDefault();
    if (!newClient.clientName.trim() || !newClient.companyName.trim()) {
      showToast("error", "Error", "Client name and company name are required.");
      return;
    }
    setAddClientLoading(true);
    addCompany({
      clientName: newClient.clientName.trim().toLowerCase(),
      companyName: newClient.companyName.trim(),
    })
      .then(({ data }) => {
        if (data.success) {
          showToast("success", "Client Added", `${newClient.companyName} has been added.`);
          setAddClientModal(false);
          setNewClient({ clientName: "", companyName: "" });
          refreshClients().then(() => setActiveClient(data.data.clientName));
        } else {
          showToast("error", "Error", data.message || "Unable to add client.");
        }
      })
      .catch((err) => {
        showToast("error", "Error", err.message || "Unable to add client.");
      })
      .finally(() => setAddClientLoading(false));
  };

  const suggestions = [
    { name: "Products", url: "/products" },
    { name: "Users", url: "/users" },
    { name: "Banners", url: "/banners" },
    { name: "Add Banner", url: "/banners/add" },
  ];


  const [query, setQuery] = useState("");
  const [filtered, setFiltered] = useState([]);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const value = e.target.value;
    setQuery(value);

    if (value.trim()) {
      const results = suggestions.filter(s =>
        s.name.toLowerCase().includes(value.toLowerCase())
      );
      setFiltered(results);
    } else {
      setFiltered([]);
    }
  };

  const handleSelect = (url) => {
    navigate(url);
    setQuery("");
    setFiltered([]);
  };

  const validateSubmit = (e) => {
    e.preventDefault();
  
    const error = {
      oldPassword: "",
      newPassword: "",
      repeatPassword: "",
      apiError: ""
    };
  
    let flag = false;
  
    if (!newPassword || newPassword.replaceAll(/\s/g, '').length < 6) {
      error.newPassword = 'Please provide a new password';
      flag = true;
    }
  
    if (repeatPassword !== newPassword) {
      error.repeatPassword = 'Password does not match';
      flag = true;
    }
  
    setErrors(error);
  
    if (!flag) {
      setLoading(true);
  
      const token = getToken(); // 👈 get token from storage
  
      updatePassword({ newPassword, token }) // 👈 send token in body
        .then(({ data }) => {
          showToast("success", "Password Changed", "Your password has been changed successfully.");
          setViewModal(false);
          setNewPassword("");
          setRepeatPassword("");
          setErrors({ oldPassword: "", newPassword: "", repeatPassword: "", apiError: "" });
        })
        .catch((e) => {
          console.error(e);
          showToast("error", "Error", "Password could not be changed.");
          setErrors({ ...error, apiError: e.message || "Something went wrong." });
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };
  



  return (
    <div className={`admin-layout ${sidebarOpen ? 'sidebar-open' : 'sidebar-closed'}`}>
      <aside className={`sidebar ${sidebarOpen ? 'open' : 'closed'}`}>
        <div className="sidebar-logo"><Link to="/dashboard" className="d-block py-1"><img src={logo} alt="logo" width={140} /></Link></div>
        <Navigation />
      </aside>
      <div className="main-content">
        <Navbar color="white" light className="topbar">
          <div className="d-flex">
            <Button color="link" className="hamburger" onClick={toggleSidebar} >
              <i className={sidebarOpen ? "ri-menu-2-fill" : "ri-menu-line"}></i>
            </Button>
            {/* <div className="search-wrapper position-relative">
              <Input type="search" placeholder="Search..." value={query} onChange={handleChange} />
              {
                query ? 
                <i className="ri-close-circle-fill topbar-search-icon cursor-pointer fs-18" onClick={() => {setQuery(""); setFiltered([])}}></i>
                :
                <i className="ri-search-line topbar-search-icon"></i>
              }
              {filtered.length > 0 && (
                <ul className="search-dropdown position-absolute bg-white border rounded shadow-sm mt-1 w-100">
                  {filtered.map((item, index) => (
                    <li key={index} onClick={() => handleSelect(item.url)} className="px-3 py-2 d-flex justify-content-between align-items-center fw-400 cursor-pointer">
                      {item.name}
                      <i className="ri-arrow-right-line"></i>
                    </li>
                  ))}
                </ul>
              )}
            </div> */}
          </div>
          <div className="d-flex align-items-center gap-3">
            <Dropdown isOpen={clientDropdownOpen} toggle={toggleClientDropdown}>
              <DropdownToggle color="outline-primary" caret className="client-dropdown-toggle">
                {clients.find((c) => c.clientName === activeClient)?.companyName || activeClient || "Select Client"}
              </DropdownToggle>
              <DropdownMenu end>
                {clients.length === 0 && <DropdownItem disabled>No clients yet</DropdownItem>}
                {clients.map((c) => (
                  <DropdownItem
                    key={c.clientName}
                    active={c.clientName === activeClient}
                    onClick={() => setActiveClient(c.clientName)}
                  >
                    {c.companyName}
                  </DropdownItem>
                ))}
                {!isClientAdmin && <DropdownItem divider />}
                {!isClientAdmin && <DropdownItem onClick={() => setAddClientModal(true)}>+ Add Client</DropdownItem>}
              </DropdownMenu>
            </Dropdown>
          <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
            <DropdownToggle color="link" className="user-dropdown">
              <div className="user-avatar d-inline-flex align-items-center justify-content-center">
                <i className="ri-user-3-line fs-18"></i>
              </div>
            </DropdownToggle>
            <DropdownMenu end>
              <DropdownItem onClick={() => setViewModal(true)}>Update Password</DropdownItem>
              <DropdownItem divider />
              <DropdownItem onClick={logout}>Logout</DropdownItem>
            </DropdownMenu>
          </Dropdown>
          </div>
        </Navbar>
        <main className="page-content">
          {props.children}
          <Modal isOpen={addClientModal} toggle={() => setAddClientModal(false)} centered size="md">
            <ModalHeader toggle={() => setAddClientModal(false)}>
              <small>Add Client</small>
            </ModalHeader>
            <ModalBody>
              <form onSubmit={handleAddClient}>
                <FormGroup>
                  <Label className="fw-600" for="clientName">Client Key</Label>
                  <Input
                    id="clientName"
                    value={newClient.clientName}
                    onChange={(e) => setNewClient({ ...newClient, clientName: e.target.value })}
                    placeholder="e.g. bindawood"
                  />
                </FormGroup>
                <FormGroup>
                  <Label className="fw-600" for="companyName">Company Name</Label>
                  <Input
                    id="companyName"
                    value={newClient.companyName}
                    onChange={(e) => setNewClient({ ...newClient, companyName: e.target.value })}
                    placeholder="e.g. BinDawood"
                  />
                </FormGroup>
                <div className="text-center mt-4">
                  <button type="submit" disabled={addClientLoading} className="btn btn-primary me-2">
                    {addClientLoading ? "Please Wait" : "Add Client"}
                  </button>
                  <button type="button" className="btn btn-outline-primary" onClick={() => setAddClientModal(false)}>Close</button>
                </div>
              </form>
            </ModalBody>
          </Modal>
          <Modal isOpen={viewModal} toggle={() => { setViewModal(false) }} centered={true} size='md'>
            <ModalHeader toggle={() => { setViewModal(false) }}>
              <small>Change Password</small>
            </ModalHeader>
            <ModalBody>
              <form onSubmit={validateSubmit}>
                <Row>
                  <Col md={12}>
                    {errors.apiError ? <Alert color="danger">{errors.apiError}</Alert> : null}

                    {/* <FormGroup className="position-relative">
                      <Label className='fw-600' for="oldPassword">Old Password</Label>
                      <Input type={showPassword.oldPassword ? "text" : "password"} id="oldPassword" value={oldPassword} onChange={(e) => { setOldPassword(e.target.value) }} placeholder="Enter your password" />
                      <i
                        className={`ri-${showPassword.oldPassword ? "eye-off" : "eye"}-line show-hide-password-icon`}
                        onClick={(e) => { setShowPassword((prev) => { return { ...prev, oldPassword: !showPassword.oldPassword } }); }}
                      ></i>
                      {errors.oldPassword ? <div className="invalid-feedback">{errors.oldPassword}</div> : null}
                    </FormGroup> */}
                    <div className="position-relative mb-1">
                      <Label className='fw-600' for="newPassword">New Password</Label>
                      <Input type={showPassword.newPassword ? "text" : "password"} id="newPassword" value={newPassword} onChange={(e) => { setNewPassword(e.target.value) }} placeholder="Enter your password" />
                      <i
                        className={`ri-${showPassword.newPassword ? "eye-off" : "eye"}-line show-hide-password-icon`}
                        onClick={(e) => { setShowPassword((prev) => { return { ...prev, newPassword: !showPassword.newPassword } }); }}
                      ></i>
                    </div>
                    {errors.newPassword ? <div className="invalid-feedback mb-2">{errors.newPassword}</div> : null}
                    <div className="position-relative mt-3">
                      <Label className='fw-600' for="repeatPassword">Repeat Password</Label>
                      <Input type={showPassword.repeatPassword ? "text" : "password"} id="repeatPassword" value={repeatPassword} onChange={(e) => { setRepeatPassword(e.target.value) }} placeholder="Enter your password" />
                      <i
                        className={`ri-${showPassword.repeatPassword ? "eye-off" : "eye"}-line show-hide-password-icon`}
                        onClick={(e) => { setShowPassword((prev) => { return { ...prev, repeatPassword: !showPassword.repeatPassword } }); }}
                      ></i>
                    </div>
                    {errors.repeatPassword ? <div className="invalid-feedback mb-2">{errors.repeatPassword}</div> : null}

                  </Col>
                  <Col md={12} className="text-center mt-4">
                    <button type="submit" disabled={loading} className="btn btn-primary me-2">{loading ? 'Please Wait' : 'Update Password'}</button>
                    <button type="button" className="btn btn-outline-primary mr-2" onClick={() => { setViewModal(false) }}>Close</button>
                  </Col>
                </Row>
              </form>
            </ModalBody>
          </Modal>
        </main>
        <ToastContainer />
      </div>
    </div>
  );
}